import Service from "../Service";

const resource = "FrzCreateTable/";

export default {
    saveNumTable(obj, NumTable, IsIntercalated, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID,
                        NumTable: NumTable,
                        IsIntercalated: IsIntercalated
             },
        });
    },

    save(obj, requestID) {
        return Service.post(resource + "saveupdate", obj, {
            params: { requestID: requestID
             },
        });
    },
    deleteMassive(obj, requestID) {
        return Service.post(resource + "deleteMassive", obj, {
            params: { requestID: requestID
             },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    list(requestID) {
        return Service.post(resource + "list", {}, {
            params: { requestID: requestID },
        });
    },
}; 